// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".b90d232850c4ac992c7ff142d609b1aa64f0cfba.chunk.bundle.js";
};